import { useNavigate, useParams } from '@tanstack/react-router';

import { ConnectionControls } from './connection-controls';
import { useRunConnectionAction } from './use-run-connection-action';

import type { WikiPerson } from '../people-wiki.types';
import type { ConnectionSurface } from './connections.query';

/** The button for the state that matters most for a person, which carries out its actions on the person's page */
export const ConnectionButton = ({
  person,
  surface = 'wiki_list',
}: {
  person: WikiPerson;
  /** Where the button is, for analytics */
  surface?: ConnectionSurface;
}) => {
  const navigate = useNavigate();
  const { personId: openPersonId } = useParams({ strict: false });
  const { click, decline, isPending } = useRunConnectionAction(
    person,
    surface,
    {
      // A page that is gone has nothing left to show, so the user leaves it when it is the page that is open
      onPageGone: () => {
        if (openPersonId === person.id) {
          void navigate({ to: '/people-wiki', replace: true });
        }
      },
    }
  );

  return (
    <ConnectionControls
      subject={person}
      click={click}
      isPending={isPending}
      surface={surface}
      decline={decline}
    />
  );
};
